import React from "react";

import { SkinInterface } from "../../../../store/roblox/skinsSlice";
import Meta, { MetaInterface } from "../../../../componets/Meta";
import IconText from "../../../../componets/IconText";
import { DownloadOutlined, HeartOutlined, LikeOutlined, MessageOutlined } from "@ant-design/icons";
import StatsIcons from "../../../../componets/StatsIcons";

interface _MetaInterface {
  skin: SkinInterface | undefined;
  size?: MetaInterface['size'];
  shape?: MetaInterface['shape'];
  showStats?: boolean;
}

const _Meta = ({ skin, shape, size, showStats }: _MetaInterface) => {
  let description: any = null;

  if (!skin) {
    return null;
  }

  if (showStats) {
    description = (
      <div>
        <StatsIcons
          icons={[
            <IconText tooltip='popular' icon={HeartOutlined} text={skin?.popular_count} />,
            <IconText tooltip='likes' icon={LikeOutlined} text={skin?.likes_count} />,
            <IconText tooltip='comments' icon={MessageOutlined} text={skin?.comments_count} />,
            <IconText tooltip='downloads' icon={DownloadOutlined} text={skin?.downloads_count} />
          ]}
        />
      </div>
    )
  }

  return (
    <Meta
      url={skin.url}
      size={size}
      shape={shape}
      avatar={skin.thumbnail_url}
      title={skin.title}
      description={description}
    />
  );
}

export default _Meta;
